import locationApi from '@/api/location';
import {handleResponseError} from '@/api/handleError'

function parseGeocodeAddress(result) {
  let street_number = result.filter((item) =>
    item.types.includes('street_number')
  );
  street_number = street_number[0] ? street_number[0].long_name : '';

  let address = result.filter((item) => item.types.includes('route'));
  address = address[0] ? address[0].short_name : '';

  let locality = result.filter((item) =>
    item.types.includes('administrative_area_level_2')
  );
  locality = locality[0] ? locality[0].long_name : '';

  let sublocality = result.filter(
    (item) =>
      item.types.includes('sublocality') ||
      item.types.includes('sublocality_level_1') ||
      item.types.includes('administrative_area_level_4')
  );
  sublocality = sublocality[0] ? sublocality[0].long_name : '';

  let administrative_area = result.filter((item) =>
    item.types.includes('administrative_area_level_1')
  );
  administrative_area = administrative_area[0]
    ? administrative_area[0].short_name
    : '';

  let postal_code = result.filter((item) =>
    item.types.includes('postal_code')
  );
  postal_code = postal_code[0] ? postal_code[0].long_name : '';

  return {
    street_number,
    address,
    locality,
    sublocality,
    administrative_area,
    postal_code
  };
}

const state = () => ({
  all: [],
  cities: [],
  labels: [],
  categories: [],
  states: [],
  exportLocations: {},
  logs: [],
  addresses: [],
  location: {},
  tasks: [],
  foodMenu: {},
  bulk: [],
  sendBulk: {},
  bulkVariables: null,
  bulkAttributes: null,
  geocodeAddresses: [],
  geocodeAddressesError: '',
  createExportLocation: null,
  locationVerification: null,
  Verification: [],
  confirmVerification:null,
  uploadFiles:[],
  uploadLocationXlsFile: null,
  uploadLocationXlsFileError:null,
  moreHourTypes: null
});

const getters = {};

const actions = {
  async getLocations({ commit }, params) {
    const result = await locationApi.getAll(params);
    if(result.data.data) {
      result.data.data.map(item => {
        const locationState = []

        if(item.state) {
          Object.keys(item.state).map(function (key) {
            if (item.state[key]) {
              switch (key) {
                case 'isDuplicate':
                  locationState.push('Duplicado');
                  break;
                case 'isSuspended':
                  locationState.push('Suspenso');
                  break;
                case 'needsReverification':
                  locationState.push('Reverificação');
                  break;
                case 'isPublished':
                  locationState.push('Publicado');
                  break;
                case 'isDisconnected':
                  locationState.push('Desconectado');
                  break;
                case 'isLocalPostApiDisabled':
                  locationState.push('Api desabilitada');
                  break;
                case 'canModifyServiceList':
                  locationState.push('Edição de serviços');
                  break;
                case 'canHaveFoodMenus':
                  locationState.push('Cardápios ativos');
                  break;
                case 'hasPendingEdits':
                  locationState.push('Edições pendentes');
                  break;
                case 'hasPendingVerification':
                  locationState.push('Em verificação');
                  break;
                default:
                  return
              }
            }
          })
        }

        item.state = locationState
      })
    }

    commit('setLocations', result.data);
  },

  async getLocation({ commit }, id) {
    const result = await locationApi.getOne(id);
    commit('setLocation', result.data);
  },

  async getCities({ commit }, params) {
    const result = await locationApi.getCities(params);
    commit('setLocationCities', result.data);
  },

  async getLabels({ commit }, params) {
    const result = await locationApi.getLabels(params);
    commit('setLocationLabels', result.data || []);
  },

  async getCategories({ commit }, params) {
    const result = await locationApi.getCategories(params);
    commit('setLocationCategories', result.data);
    return result.data;
  },

  async getLogs({ commit }, params) {
    const result = await locationApi.getLogs(params);
    commit('setLogs', result.data);
    return result
  },

  async getStates({ commit }, params) {
    const result = await locationApi.getStates(params);
    commit('setLocationStates', result.data);
  },

  async getAddresses({ commit }, params) {
    const result = await locationApi.getAddresses(params);
    commit('setLocationAddresses', result.data);
  },

  async create({ commit }, data) {
    const result = await locationApi.create(data);
    commit('setLocation', result.data);
  },

  async update({ commit }, { id, data } = {}) {
    const result = await locationApi.update(id, data);
    commit('setLocation', result.data);
  },

  async getFoodMenu({ commit }, id) {
    const result = await locationApi.getFoodMenu(id);
    commit('setFoodMenu', result.data);
  },

  async updateFoodMenu({ commit }, { id, data }) {
    const result = await locationApi.updateFoodMenu(id, data);
    commit('setFoodMenu', result.data);
  },

  async getTasks({ commit }, { id, params }) {
    const result = await locationApi.getTasks(id, params);
    commit('setLocationTasks', result.data);
  },
  async uploadLocationXlsFile({ commit }, params) {
    try{
      const result = await locationApi.uploadLocationXlsFile(params);
      commit('setUploadLocationXlsFile', result.data);
    }
    catch(e){
      commit('setUploadLocationXlsFileError', e);
    }
    
  },

  async sendVerification({ commit }, { id, data }) {
    const result = await locationApi.sendVerification(id, data);
    commit('setLocationVerification', result.data);
    return result
  },

  async getVerification({ commit }, id) {
    const result = await locationApi.getVerification(id);
    commit('setVerification', result.data);
    return result
  },

  clearFoodMenu({ commit }) {
    commit('setFoodMenu', {});
  },

  clearLocation({ commit }) {
    commit('setLocation', {});
  },

  clearLocations({ commit }) {
    commit('setLocations', null);
  },

  async getBulk({ commit }, params) {
    const result = await locationApi.getAll(params);
    commit('setBulk', result.data);
  },

  async sendBulk({ commit }, params) {
    const result = await locationApi.sendBulk(params);
    commit('sendBulk', result.data);
    return result
  },

  async exportLocations({ commit }, params){
    const result = await locationApi.exportLocations(params);
    commit('setExportLocations', result.data);
  },

  async getBulkVariables({ commit }){
    const result = await locationApi.getBulkVariables();
    commit('setBulkVariables', result.data);
  },

  async transferLocations(context, payload) {
    const result = await locationApi.transferLocations(payload)
    return result
  },

  async getBulkAttributes({ commit }, params){
    const result = await locationApi.getBulkAttributes(params);
    commit('setBulkAttributes', result.data);
  },

  async confirmVerification({ commit }, { data,id,verificationId}){
    const result = await locationApi.confirmVerification(id,verificationId,data);
    commit('setConfirmVerification', result.data);
    return result
  },

  async geocodeSearch({ commit }, { address, key }){
    return await locationApi.geocodeSearch(address, key)
      .then(res => res.json())
      .then(result => {
        if (result.status === 'OK' && Array.isArray(result.results)) {
          const parsed = result.results.map(item => {
            const addressParsed = parseGeocodeAddress(item.address_components)
            const title = addressParsed.address && addressParsed.street_number
              ? `${addressParsed.address}, ${addressParsed.street_number}`
              : item.formatted_address
            return {
              lat: item.geometry.location.lat,
              lng: item.geometry.location.lng,
              address: addressParsed,
              full_text: item.formatted_address,
              title: title
            }
          })
          commit('setGeocodeAddresses', parsed)
          return parsed
        } else {
          commit('setGeocodeAddressesError', 'Nothing found')
          return []
        }
      })
      .catch((e) => {
        console.error(e)
        commit('setGeocodeAddressesError', handleResponseError(e))
      })
  },

  clearCitiesAndStates({ commit }) {
    commit('setLocationStates', [])
    commit('setLocationCities', [])
  },

  async createExportLocations({ commit }, data){
    const result = await locationApi.createExportLocations(data);
    commit('setCreateExportLocations', result.data);
  },

  async getMoreHourTypes({ commit }){
    const result = await locationApi.getMoreHourTypes();
    commit('setMoreHourTypes', result.data);
  },
};

const mutations = {
  setLocation(state, location) {
    state.location = location;
  },
  setLocations(state, locations) {
    state.all = locations;
  },
  setLogs(state, logs) {
    state.logs = logs;
  },
  setLocationCities(state, cities) {
    state.cities = cities;
  },
  setLocationLabels(state, labels) {
    state.labels = labels;
  },
  setLocationCategories(state, categories) {
    state.categories = categories;
  },
  setLocationStates(state, states) {
    state.states = states;
  },
  setLocationAddresses(state, addresses) {
    state.addresses = addresses;
  },
  setFoodMenu(state, foodMenu) {
    state.foodMenu = foodMenu;
  },
  setLocationTasks(state, tasks) {
    state.tasks = tasks;
  },
  setBulk(state, bulk) {
    state.bulk = bulk;
  },
  setBulkVariables(state, variables) {
    state.bulkVariables = variables;
  },
  sendBulk(state, bulk) {
    state.sendBulk = bulk;
  },
  setExportLocations(state, params) {
    state.exportLocations = params;
  },
  setBulkAttributes(state, params) {
    state.bulkAttributes = params;
  },
  setGeocodeAddresses(state, result) {
    state.geocodeAddresses = result
  },
  setGeocodeAddressesError(state, e) {
    state.geocodeAddressesError = e
  },
  setCreateExportLocations(state, task) {
    state.createExportLocation = task;
  },
  setLocationVerification(state, data){
    state.locationVerification= data;
  },
  setVerification(state, data){
    state.Verification= data;
  },
  setConfirmVerification(state,data){
    state.confirmVerification=data;
  },
  setUploadLocationXlsFile(state, data){
    state.uploadLocationXlsFile = data;
  },
  setUploadLocationXlsFileError(state, e){
    state.uploadLocationXlsFileError = e;
  },
  setMoreHourTypes(state, hourTypes){
    state.moreHourTypes = hourTypes;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
